import Stripe from 'stripe';
import { z } from 'zod';

export const lineItemsSchema = z.array(
  z.object({ id: z.string().nullish(), cents: z.number(), description: z.string() })
);
export type LineItems = z.infer<typeof lineItemsSchema>;
1;
const stripeChargePartialSchema = z.object({
  id: z.string(),
  userId: z.string(),
  paymentIntent: z.string(),
  amount: z.number(),
  amountCaptured: z.number(),
  amountRefunded: z.number(),
  lineItems: lineItemsSchema,
  code: z.string().nullish(),
  json: z.string(),
});

export type StripeChargeParsed = z.infer<typeof stripeChargePartialSchema>;

// Parsing the Stripe charge object
export type StripeChargePartial = Pick<
  Stripe.Charge,
  'id' | 'metadata' | 'amount' | 'amount_captured' | 'amount_refunded' | 'payment_intent'
>;


export function parseStripeCharge(stripeCharge: StripeChargePartial) {
  const metadata = z
    .object({ userId: z.string(), lineItems: z.string(), code: z.string().nullish() })
    .parse(stripeCharge.metadata);

  return stripeChargePartialSchema.parse({
    id: stripeCharge.id,
    userId: metadata.userId,
    paymentIntent: stripeCharge.payment_intent,
    amount: stripeCharge.amount,
    amountCaptured: stripeCharge.amount_captured,
    amountRefunded: stripeCharge.amount_refunded,
    lineItems: lineItemsSchema.parse(JSON.parse(metadata.lineItems)),
    code: metadata.code,
    json: JSON.stringify(stripeCharge),
  });
}

